import { createSlice } from '@reduxjs/toolkit'
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction'
import store from 'src/store'
import {
  builderSagaCommunications,
  clearAllStateCommunications,
} from 'src/helpers/redux'

import { actions as moduleActions, PREFIX } from './actions'
import * as moduleState from './state'
import moduleSagas from './sagas'
import * as moduleSelectors from './selectors'

export const slice = createSlice({
  name: PREFIX,
  initialState: moduleState.initialState,
  reducers: {
    setSettings(
      state: moduleState.IState,
      action: PayloadAction<moduleState.IStateData['settings']>
    ) {
      state.data.settings = {
        ...state.data.settings,
        ...action.payload,
      }
    },

    setClear(state: moduleState.IState) {
      state.data = moduleState.getInitialData()
      clearAllStateCommunications(state.communication)
    },
  },
  extraReducers: (builder) => {
    builderSagaCommunications<moduleState.IState>(builder, actions)
  },
})

export * from './state'

export const setters = slice.actions
export const actions = moduleActions
export const reducers = { [PREFIX]: slice.reducer }
export const sagas = moduleSagas
export const state = moduleState
export const selectors = moduleSelectors

export const injectStore = () => {
  store.injectReducer?.(PREFIX, slice.reducer)
  store.injectSaga?.(PREFIX, sagas)
}
